<template>
  <footer class="bg-white dark:bg-gray-900 border-t border-gray-100 dark:border-gray-800 py-6">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col md:flex-row items-center justify-between gap-4">
        <div class="flex items-center gap-2">
          <span class="text-xl">🏥</span>
          <span class="text-elderly-base font-semibold text-gray-900 dark:text-white">{{ $t('common.appName') }}</span>
        </div>
        <div class="flex items-center gap-4 text-sm text-gray-500 dark:text-gray-400">
          <router-link to="/about" class="hover:text-indigo-600 dark:hover:text-indigo-400">{{ $t('about.title') }}</router-link>
          <router-link to="/privacy" class="hover:text-indigo-600 dark:hover:text-indigo-400">{{ $t('about.privacy') }}</router-link>
          <router-link to="/terms" class="hover:text-indigo-600 dark:hover:text-indigo-400">{{ $t('about.terms') }}</router-link>
          <a :href="'mailto:' + $t('about.contactEmail')" rel="noopener noreferrer" class="hover:text-indigo-600 dark:hover:text-indigo-400">📧 {{ $t('about.contactEmail') }}</a>
        </div>
        <p class="text-sm text-gray-400 dark:text-gray-500">© 2026 {{ $t('common.appName') }}</p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
</script>
